import React from "react"
import {
  Box,
  SimpleGrid,
  Image,
  AspectRatio,
  Heading as HeadingChakra,
  Text as ChakraText,
} from "@chakra-ui/react"
import { PageLayout } from "@src/features/marketing/components"
import { SEO, Container, Link } from "@src/shared/components"

const Page: React.FC = () => {
  const images = [
    {
      src: "https://res.cloudinary.com/djza4vnrm/image/upload/v1655075634/ohema/dono/Dono__1_ra8kzw.jpg",
      alt: "Dono",
      url: "/product/dono",
      price: "40",
    },
    {
      src: "https://res.cloudinary.com/djza4vnrm/image/upload/v1655075441/ohema/adinkrahene/Adinkrahene_1_aythqh.jpg",
      alt: "Adinkrahene",
      url: "/product/adinkrahene",
      price: "40",
    },
    {
      src: "https://res.cloudinary.com/djza4vnrm/image/upload/v1655075745/ohema/nyansapo/Unamed_1_woig00.jpg",
      alt: "Nyansapo",
      url: "/product/nyansapo",
      price: "40",
    },
  ]
  return (
    <>
      <SEO
        title="AKAN GOLDWEIGHTS BRACELETS COLLECTION | Ohema"
        robots="index, follow"
        description="Add these dainty and elegant pieces of jewelry to your collection and step into the queen you already are."
        keywords="African jewelry, Akan GoldWeights Bracelets"
        pathName="products"
        type="product"
        banner="images/ohema-og-image.jpeg"
      />
      <PageLayout>
        <Container>
          <HeadingChakra
            as="h1"
            fontSize={{ sm: "l", md: "xl" }}
            maxWidth={{ sm: "sm", md: "xl" }}
            mb={8}
            mt={4}
            color="#6c6c6c"
          >
            AKAN GOLDWEIGHTS BRACELETS COLLECTION
          </HeadingChakra>
          <SimpleGrid columns={{ sm: 2, md: 3 }} spacing={6}>
            {images.map((image, index) => {
              return (
                <>
                  <Link
                    href={image.url}
                    textDecoration="none"
                    _hover={{ textDecoration: "none" }}
                  >
                    <Box key={index}>
                      <AspectRatio maxH="400px" ratio={3 / 4}>
                        <Image
                          src={image.src}
                          alt={image.alt}
                          objectFit="cover"
                        />
                      </AspectRatio>
                    </Box>
                    <HeadingChakra
                      as="h2"
                      mt={4}
                      fontSize="1.1rem"
                      color="#5C5C5C"
                    >
                      {image.alt}
                    </HeadingChakra>
                    <ChakraText fontSize="1rem" mt={1} fontWeight="light">
                      {image.price} $CA
                    </ChakraText>
                  </Link>
                </>
              )
            })}
          </SimpleGrid>
        </Container>
      </PageLayout>
    </>
  )
}

export default Page
